module.exports = __webpack_public_path__ + "assets/img/ICI-UK-Content-Marketing-w720.0a67e106.jpg";